import PropTypes from 'prop-types';
import React from 'react';

import { cn } from 'utils/Tailwind';

const ButtonSwitch = ({
  ariaLabel,
  className,
  onClick,
  isSwitched,
  isValid,
  children,
  ...props
}) => (
  <button
    className={cn(
      className,
      'cursor-pointer rounded-sm border border-solid px-4 py-1 text-center text-sm font-bold uppercase',
      {
        'rounded-none border-none shadow-inputError': isValid === false,
        'border-white bg-black text-white': isSwitched,
        'border-black bg-white text-gray-600': !isSwitched,
      }
    )}
    onClick={onClick}
    aria-label={ariaLabel}
    {...props}
  >
    {children}
  </button>
);

ButtonSwitch.propTypes = {
  ariaLabel: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  isSwitched: PropTypes.bool,
  isValid: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

ButtonSwitch.defaultProps = {
  ariaLabel: '',
  className: '',
  onClick: () => {},
  isSwitched: false,
  isValid: true,
  children: null,
};

export default ButtonSwitch;
